module.exports = __webpack_public_path__ + "static/media/equal-light-blue.bb308c1e.svg";